// TelcoTrack — weld visual rails by dest/role, not incoming/outgoing.
// Left = primary (zafouknuto do rozvaděče). Right = secondary (zafouknuto do budovy).

import type { RozvadecWeldLayoutCable } from './rozvadec-weld-layout.types';

export const BUDOVA_WELD_CABLE_ID_PREFIX = 'budova:';

export type WeldVisualDestRole = 'rozvadec' | 'budova';
export type WeldCableFiberRole = 'incoming' | 'outgoing';

export type WeldRailAssignedCable = {
  cable: RozvadecWeldLayoutCable;
  destRole: WeldVisualDestRole;
  fiberRole: WeldCableFiberRole;
};

export type WeldRailAssignment = {
  left: WeldRailAssignedCable[];
  right: WeldRailAssignedCable[];
};

export function isBudovaWeldCableId(cableId: string | null | undefined): boolean {
  return (cableId ?? '').trim().startsWith(BUDOVA_WELD_CABLE_ID_PREFIX);
}

/** Dest/role of a weld cable: building drop vs cabinet / primary OK / transport. */
export function weldCableDestRole(
  cable: Pick<RozvadecWeldLayoutCable, 'cableId'>,
): WeldVisualDestRole {
  return isBudovaWeldCableId(cable.cableId) ? 'budova' : 'rozvadec';
}

/**
 * Assign incoming + outgoing cables to visual rails.
 * Incoming/outgoing is the fiber endpoint role, never the side:
 * every dest=rozvaděč cable stays left (stacked); dest=budova stays right (stacked).
 */
export function assignWeldCablesToRails(
  incoming: readonly RozvadecWeldLayoutCable[],
  outgoing: readonly RozvadecWeldLayoutCable[],
): WeldRailAssignment {
  const tagged: WeldRailAssignedCable[] = [
    ...incoming.map((cable) => ({
      cable,
      destRole: weldCableDestRole(cable),
      fiberRole: 'incoming' as const,
    })),
    ...outgoing.map((cable) => ({
      cable,
      destRole: weldCableDestRole(cable),
      fiberRole: 'outgoing' as const,
    })),
  ];
  return {
    left: tagged.filter((row) => row.destRole === 'rozvadec'),
    right: tagged.filter((row) => row.destRole === 'budova'),
  };
}
